module.exports = __webpack_public_path__ + "img/tutorial-thumbnail.0529a53a.png";